import React, { useState } from 'react';
import { Box, Typography, Paper, FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { CustomRadarChart } from '../../components/RadarChart';
import { PaceReport } from '../../components/PaceReport';

type ReportType = 'progress' | 'pace';

export const Reports: React.FC = () => {
  const [reportType, setReportType] = useState<ReportType>('progress');

  const handleReportTypeChange = (event: SelectChangeEvent) => {
    setReportType(event.target.value as ReportType);
  };

  const renderProgressReport = () => (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        backgroundColor: 'background.paper',
        borderRadius: 2,
        mt: 2
      }}
    >
      <Typography variant="h6" gutterBottom>
        Category Progress Overview
      </Typography>
      <Box sx={{ height: 500 }}>
        <CustomRadarChart />
      </Box>
    </Paper>
  );

  const renderPaceReport = () => (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        backgroundColor: 'background.paper',
        borderRadius: 2,
        mt: 2
      }}
    >
      <Typography variant="h6" gutterBottom>
        User Pace Analysis
      </Typography>
      <Box sx={{ height: 500 }}>
        <PaceReport />
      </Box>
    </Paper>
  );

  return (
    <Box sx={{ padding: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" sx={{ mr: 2 }}>
          Reports
        </Typography>
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <Select
            value={reportType}
            onChange={handleReportTypeChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Report type' }}
          >
            <MenuItem value="progress">Progress Report</MenuItem>
            <MenuItem value="pace">Pace Report</MenuItem>
          </Select>
        </FormControl>
      </Box>
      
      {reportType === 'progress' ? renderProgressReport() : renderPaceReport()}
    </Box>
  );
};

export default Reports;
